import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { LoggerService } from './logger.service';

@Injectable()
export class ProviderServiceService {
  providerServices: any[] = [];

  constructor(
    private http: HttpService,
    private logger: LoggerService,
  ) {}

  getProviderServices() {
    return new Promise((resolve, reject) => {
      this.http.get('provider-services/list').subscribe(
        (resp: any) => {
          this.providerServices = resp.data;
          this.logger.log('providerServices:', this.providerServices);

          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }
}
